<template>
    <div id="allBetHeader" v-if="arr_allBetEvent">
        <loadingScreen :loading="loadingScreen"></loadingScreen>
        <div data-v-7718c41e="" class="q-page-container -page-container- wrapper-scroller"> <!--<style="height: 844px; overflow-y: auto;">-->
            <div data-v-58c1d432="" data-v-7718c41e="">
                <div data-v-58c1d432="" class="details-fat scroll relative-position details-bet" style="height: 100vh;" :class="{'show-video':!closeTvWindow}"> <!--<style="height: 844px;" :class="{'show-video':!closeTvWindow}">-->
                    <div data-v-58c1d432="" class="header-fix">
                        <div data-v-58c1d432="" class="relative-position scroll_video_h">
                            <div data-v-7508f7a8="" data-v-58c1d432="" class="player" v-if="!closeTvWindow && tvlink && tvlink!='error'" >
                                <div data-v-6b63be36="" data-v-58c1d432="" class="change-header">
                                    <div data-v-6b63be36="" class="bg-wrap" :style="sportBackground(arr_selectedTemplate.sportId, 0)"></div>
                                    <div data-v-6b63be36="" class="h-row row mx-15">
                                        <div data-v-6b63be36="" class="col-1 go-back-container"  @click="videoClose()" style="display:block !important;padding-top:5px">
                                            <div data-v-6b63be36="" class="go-back"></div>
                                        </div>
                                        <div data-v-6b63be36="" class="col-2 text-left ellipsis base-header-font" :class="checkPersian(arr_allBetEvent.tacapt)" v-html="arr_allBetEvent.tacapt"></div>
                                            <template v-if="arr_allBetEvent.rbinfo && (arr_allBetEvent.sptid==1 || arr_allBetEvent.sptid==2)">
                                                <div data-v-6b63be36="" class="col-6 row">
                                                    <div data-v-6b63be36="" class="col-2 text-center header-font">{{arr_allBetEvent.rbinfo.scoa}} </div>
                                                    <div data-v-6b63be36="" class="col text-center base-header-font">
                                                        <div data-v-33858d13="" data-v-6b63be36="" class="match_stage">
                                                            <span data-v-33858d13="">
                                                                <span data-v-c8b324f0="" data-v-33858d13="" class="dialogStage_1">
                                                                    <span data-v-c8b324f0="" >
                                                                        <template v-if="arr_allBetEvent.sptid==1">
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '0'">{{ sportAllBetLang['ALL_BET.LBL_HT'] }}</template>
                                                                            <template v-else-if="validateRBTimer(arr_allBetEvent) == '1'">{{ sportAllBetLang['ALL_BET.LBL_HT1'] }}</template>
                                                                            <template v-else-if="validateRBTimer(arr_allBetEvent) == '2'">{{ sportAllBetLang['ALL_BET.LBL_HT2'] }}</template>
                                                                        </template>
                                                                        <template v-else>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '1'">{{ sportAllBetLang['ALL_BET.LBL_Q1'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '2'">{{ sportAllBetLang['ALL_BET.LBL_Q2'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '3'">{{ sportAllBetLang['ALL_BET.LBL_Q3'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '4'">{{ sportAllBetLang['ALL_BET.LBL_Q4'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '5'">{{ sportAllBetLang['ALL_BET.LBL_1HT'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '6'">{{ sportAllBetLang['ALL_BET.LBL_HT_SHOR'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '7'">{{ sportAllBetLang['ALL_BET.LBL_2HT'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '8'">{{ sportAllBetLang['ALL_BET.LBL_OT'] }}</template>
                                                                        </template>
                                                                        <span data-v-c8b324f0="">
                                                                            <span data-v-c8b324f0="">&nbsp;&nbsp;{{ arr_allBetEvent | rb-timer }}</span>
                                                                        </span>
                                                                    </span>
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div data-v-6b63be36="" class="col-2 text-center header-font">{{arr_allBetEvent.rbinfo.scob}} </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div data-v-6b63be36="" class="col-6 row">
                                                    <div data-v-6b63be36="" class="col-2 text-center header-font" style="display: none;">0</div>
                                                    <div data-v-6b63be36="" class="col text-center base-header-font">
                                                        <div data-v-33858d13="" data-v-6b63be36="" class="match_stage">
                                                        <span data-v-33858d13="">
                                                        {{ getDate(matchDateCheck(arr_allBetEvent.dt)) }}
                                                        </span>
                                                        </div>
                                                    </div>
                                                    <div data-v-6b63be36="" class="col-2 text-center header-font" style="display: none;">0</div>
                                                </div>
                                            </template>
                                        <div data-v-6b63be36="" class="col-2 text-right ellipsis base-header-font" :class="checkPersian(arr_allBetEvent.tbcapt)" v-html="arr_allBetEvent.tbcapt"></div>
                                    </div>
                                </div>
                                <div data-v-7508f7a8="" class="top-space">
                                    <div data-v-7508f7a8="" class="iframe-wrap DJ-score-information stickyed" style="width: 100%; height: 2.11rem;">
                                        <iframe data-v-7508f7a8="" id="bdIframe" allow="autoplay" frameborder="0" scrolling="no" :src="tvlink" style="width: 100%; height: 100%;"></iframe><!---->
                                        <div data-v-7508f7a8="" class="bg" style="display: none;"></div>
                                        <div data-v-6fc7563b="" data-v-7508f7a8="" class="football-events  yb_ml10 fullscreen">
                                            <div data-v-6fc7563b="" class="img-wrap yb_mb10 yb_ml4"></div>
                                            <div data-v-6fc7563b="" class="info-wrap yb_px4 yb_py4 relative-position">
                                            <p data-v-6fc7563b="" class="row justify-between yb"><span data-v-6fc7563b="" class="ellipsis yb_mr8" style="flex: 1 1 0%;" v-html="arr_allBetEvent.tacapt"></span><span data-v-6fc7563b="" class="text-right" style="width: 0.36rem;"></span></p>
                                            </div>
                                        </div>
                                        <div data-v-7508f7a8="" class="title" style="display: none;">
                                            <div data-v-7508f7a8="" class="row justify-between full-height mx-15">
                                            <div data-v-7508f7a8="" class="col-1 go-back-btn-wrap" @click="videoClose()">
                                                <div data-v-7508f7a8="" class="video_back"></div>
                                            </div>
                                            <div data-v-7508f7a8="" class="col-10 row" style="max-width: 2.43rem;">
                                                <div data-v-7508f7a8="" class="col title-text-style" :class="checkPersian(arr_allBetEvent.tacapt)"  v-html="arr_allBetEvent.tacapt"></div>
                                                <template v-if="arr_allBetEvent.rbinfo && (arr_allBetEvent.sptid==1 || arr_allBetEvent.sptid==2)">
                                                    <div data-v-7508f7a8="" class="col title-text-style" style="visibility: visible;">{{arr_allBetEvent.rbinfo.scoa}} - {{arr_allBetEvent.rbinfo.scob}}</div>
                                                </template>
                                                <template v-else>
                                                    <div data-v-7508f7a8="" class="col title-text-style" style="visibility: visible;">{{ getTime(matchDateCheck(arr_allBetEvent.dt)) }}</div>
                                                </template>
                                                <div data-v-7508f7a8="" class="col title-text-style" :class="checkPersian(arr_allBetEvent.tbcapt)" v-html="arr_allBetEvent.tbcapt"></div>
                                            </div>
                                            <div data-v-7508f7a8="" class="col-1"></div>
                                            </div>
                                        </div>
                                        <div data-v-7508f7a8="" class="full-screen-btn" style="display: none;"><img data-v-7508f7a8="" src="assets/images/score/full_screen.svg"></div>
                                        <div data-v-7508f7a8="" class="description-popup" style="display: none;">
                                            <!---->
                                            <div data-v-7508f7a8="" class="img-wrap"><img data-v-7508f7a8="" src="assets/images/score/video_b.svg"></div>
                                        </div>
                                        <!--div data-v-7508f7a8="" class="full-screen-btn" style="display:none ;">
                                            <img data-v-7508f7a8="" src=src="assets/images/score/pack_up.svg">
                                        </div-->
                                    </div>
                                </div>
                                <!----><!---->
                            </div>
                            <div data-v-722424a7="" data-v-58c1d432="" class="details-header" :style="sportBackground(arr_selectedTemplate.sportId, 1)"  v-if="closeTvWindow" >
                            <div data-v-6173da5c="" data-v-722424a7="" class="common-header">
                                <div data-v-6173da5c="" class="row justify-between full-height mx-15">
                                    <div data-v-6173da5c="" class="go-back-btn-wrap a1" @click="goBack">
                                        <div data-v-6173da5c="" class="go-back"></div>
                                    </div>
                                    <div data-v-6173da5c="" class="ellipsis title-style details-c" @click="showMoreMatch()">
                                        <div data-v-9403808a="" data-v-6173da5c="" class="marquee-wrap">
                                            <div data-v-9403808a="" class="scroll_wrap" style="animation: 7.6875s linear 0s infinite normal none running titleScroll;">
                                                <p data-v-9403808a="" class="marquee" style="margin-right: 16px;" id="myDiv" :class="checkPersian(arr_allBetEvent.lgecapt)" v-html="arr_allBetEvent.lgecapt"></p> <!--  v-html="content" -->
                                                <!--<p data-v-9403808a="" class="copy">{{ arr_allBetEvent.lgecapt }}</p>-->
                                            </div>
                                            <p data-v-9403808a="" class="full_content" :class="checkPersian(arr_allBetEvent.lgecapt)" v-html="arr_allBetEvent.lgecapt"></p>
                                        </div>
                                        &nbsp;
                                        <span data-v-6173da5c="" class="triangle-down"></span>
                                    </div>
                                    <div data-v-6173da5c="" class="row common-header-right">
                                        <div data-v-6173da5c="" class="det-ref refreshing-common" :class="{'refreshing':refreshAllBet}" @click="reloadAllBetTable"></div>
                                    </div>
                                </div>
                            </div>
                            <div data-v-49969bd3="" data-v-722424a7="" class="relative-position header-top">
                                <div data-v-49969bd3="" class="row mx-30 top-style">
                                    <div data-v-49969bd3="" class="col-3 logo-double">
                                        <div data-v-507efc54="" data-v-49969bd3="" class="team-img" v-if="account.showCtrLogo && arr_allBetEvent.sptid == 1 || arr_allBetEvent.sptid == 2">
                                                <img data-v-507efc54="" alt="" class="img-style" data-team="J" data-csid="1" v-bind:src="arr_allBetEvent.tblogo">
                                            </div>
                                    </div>
                                    <template v-if="arr_allBetEvent.rbinfo && (arr_allBetEvent.sptid==1 || arr_allBetEvent.sptid==2)">
                                        <div data-v-49969bd3="" class="col-6"> 
                                            <div data-v-0b6b47eb="" data-v-49969bd3="" class="team-text">
                                                <span data-v-0b6b47eb="" class="style_icon" v-if="arr_allBetEvent.ha=='N'"><img data-v-0b6b47eb="" src="assets/images/score/zhonglichang.svg" alt=""></span>
                                                <span data-v-0b6b47eb="" class="base-header-font">
                                                    <div data-v-553ff1f6="" data-v-0b6b47eb="" class="match_stage">
                                                        <span data-v-553ff1f6="">
                                                            <span data-v-553ff1f6="">
                                                                <span data-v-8edd72a2="" data-v-553ff1f6="" class="stage_child_1">
                                                                    <span data-v-8edd72a2="">
                                                                        <template v-if="arr_allBetEvent.sptid==1">
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '0'">{{ sportAllBetLang['ALL_BET.LBL_HT'] }}</template>
                                                                            <template v-else-if="validateRBTimer(arr_allBetEvent) == '1'">{{ sportAllBetLang['ALL_BET.LBL_HT1'] }}</template>
                                                                            <template v-else-if="validateRBTimer(arr_allBetEvent) == '2'">{{ sportAllBetLang['ALL_BET.LBL_HT2'] }}</template>
                                                                            <span data-v-8edd72a2="">&nbsp;{{ arr_allBetEvent | rb-timer }}</span>
                                                                        </template>
                                                                        <template v-else>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '1'">{{ sportAllBetLang['ALL_BET.LBL_Q1'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '2'">{{ sportAllBetLang['ALL_BET.LBL_Q2'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '3'">{{ sportAllBetLang['ALL_BET.LBL_Q3'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '4'">{{ sportAllBetLang['ALL_BET.LBL_Q4'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '5'">{{ sportAllBetLang['ALL_BET.LBL_1HT'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '6'">{{ sportAllBetLang['ALL_BET.LBL_HT_SHOR'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '7'">{{ sportAllBetLang['ALL_BET.LBL_2HT'] }}</template>
                                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '8'">{{ sportAllBetLang['ALL_BET.LBL_OT'] }}</template>
                                                                            <span data-v-8edd72a2="">&nbsp;{{ arr_allBetEvent | rb-timer }}</span>
                                                                        </template>
                                                                    </span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div data-v-49969bd3="" class="col-6">
                                            <div data-v-0b6b47eb="" data-v-49969bd3="" class="team-text">
                                                <span data-v-0b6b47eb="" class="style_icon" v-if="arr_allBetEvent.ha=='N'"><img data-v-0b6b47eb="" src="assets/images/score/zhonglichang.svg" alt=""></span>
                                                <span data-v-0b6b47eb="" class="base-header-font">
                                                <div data-v-553ff1f6="" data-v-0b6b47eb="" class="match_stage">
                                                    <span data-v-553ff1f6="">
                                                        <span data-v-553ff1f6="">
                                                            <span data-v-553ff1f6="" v-if="checkStart(arr_allBetEvent.dt)<60">
                                                                {{ sportTableLang['SPORT_TABLE.START_IN'].replace('{minute}',checkStart(arr_allBetEvent.dt)) }}
                                                            </span>
                                                            <span data-v-553ff1f6="" v-else> {{ getDate(matchDateCheck(arr_allBetEvent.dt)) }}</span>
                                                        </span>
                                                    </span>
                                                </div>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <div data-v-49969bd3="" class="col-3 logo-double">
                                        <div data-v-507efc54="" data-v-49969bd3="" class="team-img"  v-if="account.showCtrLogo && arr_allBetEvent.sptid == 1 || arr_allBetEvent.sptid == 2">
                                            <img data-v-507efc54="" alt="" class="img-style" data-team="B" data-csid="1" v-bind:src="arr_allBetEvent.talogo">
                                        </div>
                                    </div>
                                </div>
                                <div data-v-49969bd3="" class="score-style">
                                    <template v-if="arr_allBetEvent.rb==0">
                                        
                                        <span data-v-49969bd3="" v-if="checkStart(arr_allBetEvent.dt)<60">
                                        <!--    {{ sportTableLang['SPORT_TABLE.START_IN'].replace('{minute}',checkStart(arr_allBetEvent.dt)) }} -->
                                        </span>
                                        <span data-v-49969bd3="" v-else>
                                            <span data-v-49969bd3="">{{ getTime(matchDateCheck(arr_allBetEvent.dt)) }}</span>
                                        </span>
                                    </template>
                                    <template v-else>
                                        <template v-if="arr_allBetEvent.rbinfo && (arr_allBetEvent.sptid==1 || arr_allBetEvent.sptid==2)">
                                            <span data-v-49969bd3="" class="score1">{{arr_allBetEvent.rbinfo.scoa}} - {{arr_allBetEvent.rbinfo.scob}}</span>
                                        </template>
                                        <template v-else>
                                            <span data-v-49969bd3="" class="score1"  v-if="checkStart(arr_allBetEvent.dt)<60">
                                            </span>
                                            <span data-v-49969bd3="" class="score1"  v-else>{{ getTime(matchDateCheck(arr_allBetEvent.dt)) }}</span>
                                        </template>
                                        <div data-v-1ad51395="" data-v-49969bd3="" class="match_between_score score-ball din-regular"></div>
                                    </template>
                                </div>
                                <div data-v-49969bd3="" class="mx-4 row team-name">
                                    <div data-v-49969bd3="" class="row name-wrap mhn">
                                        <div data-v-49969bd3="" class="mhn-name ellipsis-2-lines" :class="checkPersian(arr_allBetEvent.tacapt)"  v-html="arr_allBetEvent.tacapt"></div>
                                        <div data-v-49969bd3="" class="red-gif">
                                            <div data-v-49969bd3="" class="inner left"></div>
                                        </div>
                                    </div>

                                    <div data-v-49969bd3="" class="row name-wrap">
                                        <div data-v-49969bd3="" class="red-gif">
                                            <div data-v-49969bd3="" class="inner right"></div>
                                        </div>
                                        <div data-v-49969bd3="" class="man-name ellipsis-2-lines" :class="checkPersian(arr_allBetEvent.tbcapt)"  v-html="arr_allBetEvent.tbcapt"></div>
                                    </div>
                                </div>
                            </div>
                            <div data-v-3581e3c7="" data-v-722424a7="" class="header-bottom margin_left_bottom">
                                <div data-v-50fa4088="" data-v-3581e3c7="" class="team-match-icon">
                                    <div data-v-50fa4088="" class="icon-wrap">
                                        <div data-v-e2136514="" data-v-50fa4088="" class="match-icon fl" v-if="arr_allBetEvent.rbinfo && arr_allBetEvent.ch != 0 && tvIconFlag"  @click="startTv(arr_allBetEvent)">
                                            <div data-v-e2136514="" class="row mx-8 items-center">
                                                <img data-v-e2136514="" src="assets/images/score/shipin.svg" alt="" class="icon-style">
                                                <div data-v-e2136514="" class="col text-left">
                                                    <span data-v-e2136514="" class="tx-style">{{ sportAllBetLang['ALL_BET.VIDEO'] }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div data-v-50fa4088="" class="match-icon match-icon-single"  @click="favouriteAllBet(arr_allBetEvent, isRB)">
                                            <div data-v-50fa4088="" class="collect-icon" :class="arr_allBetEvent.isFavourite?'active':''"></div>
                                            <div data-v-50fa4088="" class="text">{{ sportAllBetLang['ALL_BET.FAVOURITES'] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="arr_allBetEvent.rbinfo && arr_allBetEvent.sptid==1">
                                    <span data-v-3581e3c7="">
                                        <div data-v-126a0a7d="" data-v-3581e3c7="" class="match_score">
                                            <div data-v-8c6648dc="" data-v-126a0a7d="" class="score_child_1 row mx-12 font-style">
                                                <div data-v-8c6648dc=""  v-if="arr_allBetEvent.rbinfo.htscoa!=''">
                                                    <div data-v-8c6648dc="">
                                                        <span data-v-8c6648dc="">&nbsp;&nbsp;</span>
                                                        <span data-v-8c6648dc=""> {{ sportAllBetLang['ALL_BET.LBL_H'] }}</span>
                                                        <span data-v-8c6648dc=""> : 
                                                            <template v-if="arr_allBetEvent.rbinfo.htscoa!=''&&arr_allBetEvent.rbinfo.htscob!=''">{{arr_allBetEvent.rbinfo.htscoa}} - {{arr_allBetEvent.rbinfo.htscob}}</template>
                                                            <template v-else>{{arr_allBetEvent.rbinfo.scoa}} - {{arr_allBetEvent.rbinfo.scob}}</template>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div data-v-8c6648dc="">
                                                    <span data-v-8c6648dc="">&nbsp;&nbsp;</span>
                                                    <!--span data-v-8c6648dc="">
                                                        <span data-v-8c6648dc="">&nbsp;&nbsp;</span>
                                                        <span data-v-8c6648dc="">
                                                            <div data-v-8c6648dc="" role="img" class="q-img overflow-hidden" style="width: 0.12rem; margin-top: -3px;">
                                                                <div style="padding-bottom: 100%;"></div>
                                                                <div class="q-img__image absolute-full" style="background-size: cover; background-position: 50% 50%; background-image: url('assets/images/score/details_yellow.svg');"></div>
                                                                <div class="q-img__content absolute-full"></div>
                                                            </div>
                                                        </span>
                                                        <span data-v-8c6648dc="">&nbsp;&nbsp;</span>
                                                        <span data-v-8c6648dc="">1-0</span>
                                                    </span-->
                                                    <span data-v-8c6648dc="">
                                                        <span data-v-8c6648dc="">&nbsp;&nbsp;</span>
                                                        <span data-v-8c6648dc="">
                                                            <div data-v-8c6648dc="" role="img" class="q-img overflow-hidden" style="width: 0.12rem; margin-top: -3px;">
                                                                <div style="padding-bottom: 100%;"></div>
                                                                <div class="q-img__image absolute-full" style="background-size: cover; background-position: 50% 50%; background-image: url('assets/images/score/details_red_card.svg');"></div>
                                                                <div class="q-img__content absolute-full"></div>
                                                            </div>
                                                        </span>
                                                        <span data-v-8c6648dc="">&nbsp;&nbsp;</span>
                                                        <span data-v-8c6648dc="">{{ arr_allBetEvent.rbinfo.rca }}-{{ arr_allBetEvent.rbinfo.rcb }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-v-58c1d432="" class="mini-header-container" style="visibility: hidden;" ref="miniHeader">
                    <div data-v-6b63be36="" data-v-58c1d432="" class="change-header">
                        <div data-v-6b63be36="" class="bg-wrap" :style="sportBackground(arr_selectedTemplate.sportId, 0)"></div>
                        <div data-v-6b63be36="" class="h-row row mx-15">
                            <div data-v-6b63be36="" class="col-1 go-back-container" @click="goBack">
                                <div data-v-6b63be36="" class="go-back"></div>
                            </div>
                            <div data-v-6b63be36="" class="col-2 text-left ellipsis base-header-font" :class="checkPersian(arr_allBetEvent.tacapt)"  v-html="arr_allBetEvent.tacapt"></div>
                            <template v-if="arr_allBetEvent.rbinfo && (arr_allBetEvent.sptid==1 || arr_allBetEvent.sptid==2)">
                                <div data-v-6b63be36="" class="col-6 row">
                                    <div data-v-6b63be36="" class="col-2 text-center header-font">{{arr_allBetEvent.rbinfo.scoa}} </div>
                                    <div data-v-6b63be36="" class="col text-center base-header-font">
                                        <div data-v-33858d13="" data-v-6b63be36="" class="match_stage">
                                            <span data-v-33858d13="">
                                                <span data-v-c8b324f0="" data-v-33858d13="" class="dialogStage_1">
                                                    <span data-v-c8b324f0="" >
                                                        <template v-if="arr_allBetEvent.sptid==1">
                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '0'">{{ sportAllBetLang['ALL_BET.LBL_HT'] }}</template>
                                                            <template v-else-if="validateRBTimer(arr_allBetEvent) == '1'">{{ sportAllBetLang['ALL_BET.LBL_HT1'] }}</template>
                                                            <template v-else-if="validateRBTimer(arr_allBetEvent) == '2'">{{ sportAllBetLang['ALL_BET.LBL_HT2'] }}</template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '1'">{{ sportAllBetLang['ALL_BET.LBL_Q1'] }}</template>
                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '2'">{{ sportAllBetLang['ALL_BET.LBL_Q2'] }}</template>
                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '3'">{{ sportAllBetLang['ALL_BET.LBL_Q3'] }}</template>
                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '4'">{{ sportAllBetLang['ALL_BET.LBL_Q4'] }}</template>
                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '5'">{{ sportAllBetLang['ALL_BET.LBL_1HT'] }}</template>
                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '6'">{{ sportAllBetLang['ALL_BET.LBL_HT_SHOR'] }}</template>
                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '7'">{{ sportAllBetLang['ALL_BET.LBL_2HT'] }}</template>
                                                            <template v-if="arr_allBetEvent.rbinfo.htst == '8'">{{ sportAllBetLang['ALL_BET.LBL_OT'] }}</template>
                                                        </template>
                                                        <span data-v-c8b324f0="">
                                                            <span data-v-c8b324f0="">&nbsp;&nbsp;{{ arr_allBetEvent | rb-timer }}</span>
                                                        </span>
                                                    </span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div data-v-6b63be36="" class="col-2 text-center header-font">{{arr_allBetEvent.rbinfo.scob}} </div>
                                </div>
                            </template>
                            <template v-else>
                                <div data-v-6b63be36="" class="col-6 row">
                                    <div data-v-6b63be36="" class="col-2 text-center header-font" style="display: none;">0</div>
                                    <div data-v-6b63be36="" class="col text-center base-header-font">
                                        <div data-v-33858d13="" data-v-6b63be36="" class="match_stage">
                                            <span data-v-681648d4="" v-if="checkStart(arr_allBetEvent.dt)<60">
                                                    {{ sportTableLang['SPORT_TABLE.START_IN'].replace('{minute}',checkStart(arr_allBetEvent.dt)) }}
                                            </span>
                                            <span data-v-33858d13="" v-else>
                                                {{ getDate(matchDateCheck(arr_allBetEvent.dt)) }}
                                            </span>
                                        </div>
                                    </div>
                                    <div data-v-6b63be36="" class="col-2 text-center header-font" style="display: none;">0</div>
                                </div>
                            </template>
                            <div data-v-6b63be36="" class="col-2 text-right ellipsis base-header-font" :class="checkPersian(arr_allBetEvent.tbcapt)" v-html="arr_allBetEvent.tbcapt"></div>
                        </div>
                    </div>
                </div>
                <div data-v-58c1d432="" class="play-wrapper bet-wrapper-hide" id="tbl" style="display:none">
                    <div data-v-58c1d432="" class="details-tab-wrap">
                        <div data-v-58c1d432="" role="tablist" class="q-tabs row no-wrap items-center bg-tabs q-tabs--not-scrollable q-tabs--horizontal q-tabs__arrows--inside col-shrink self-stretch">
                            <div class="q-tabs__content row no-wrap items-center self-stretch hide-scrollbar relative-position q-tabs__content--align-justify tab-bet-wrapper scroll">
                            <div data-v-58c1d432="" tabindex="0" role="tab" aria-selected="true" class="q-tab relative-position self-stretch flex flex-center text-center no-outline q-tab--active text-active-tab bg-active-tab q-focusable q-hoverable cursor-pointer">
                                <div tabindex="-1" class="q-focus-helper"></div>
                                <div class="q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable row no-wrap q-tab__content--inline ">
                                <div class="q-tab__label">{{ sportAllBetLang['ALL_BET.BET'] }}</div>
                                </div>
                            </div>
                            <div class="q-tab__indicator absolute-top"></div>
                            </div>
                            <!--<div data-v-58c1d432="" tabindex="0" role="tab" aria-selected="false" class="q-tab relative-position self-stretch flex flex-center text-center no-outline q-tab--inactive q-focusable q-hoverable cursor-pointer">
                            <div tabindex="-1" class="q-focus-helper"></div>
                            <div class="q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable row no-wrap q-tab__content--inline tab-match-analysis">
                                <div class="q-tab__label">赛事分析</div>
                            </div>
                            <div class="q-tab__indicator absolute-top"></div>
                            </div>-->
                        </div>
                        <div data-v-064a5016="" data-v-58c1d432="" class="details-tab">
                            <div data-v-064a5016="" class="fat-btn" @click="showHideAllOdds()">
                                <div data-v-064a5016="" class="tab-btn" :class="{'collapsed':isCollapse}"></div>
                            </div>
                            <span data-v-064a5016="" class="menu-third"></span>
                            <div data-v-064a5016="" class="menu-s">
                                <div data-v-064a5016="" class="menu-s">
                                    <template v-if="selectedGrp.includes(7)"><div data-v-064a5016="" class="menu-item" :class="{'t_color':arr_selectedBetTab == 7}" @click="changeBetTab(7)">{{ sportAllBetLang['ALL_BET.ALL'] }}</div></template>
                                    <template v-if="selectedGrp.includes(8)"><div data-v-064a5016="" class="menu-item" :class="{'t_color':arr_selectedBetTab == 8}" @click="changeBetTab(8)">{{ sportAllBetLang['ALL_BET.HOT'] }}</div></template>
                                    <template v-if="selectedGrp.includes(1)"><div data-v-064a5016="" class="menu-item" :class="{'t_color':arr_selectedBetTab == 1}" @click="changeBetTab(1)">{{ sportAllBetLang['ALL_BET.HDP'] }}{{ sportAllBetLang['ALL_BET.AND'] }}{{ sportAllBetLang['ALL_BET.OU'] }}</div></template>
                                    <template v-if="selectedGrp.includes(2)"><div data-v-064a5016="" class="menu-item" :class="{'t_color':arr_selectedBetTab == 2}" @click="changeBetTab(2)">{{ sportAllBetLang['ALL_BET.GOALS'] }}</div></template>
                                    <template v-if="selectedGrp.includes(3)"><div data-v-064a5016="" class="menu-item" :class="{'t_color':arr_selectedBetTab == 3}" @click="changeBetTab(3)">{{ sportAllBetLang['ALL_BET.CS'] }}</div></template>
                                    <template v-if="selectedGrp.includes(4)"><div data-v-064a5016="" class="menu-item" :class="{'t_color':arr_selectedBetTab == 4}" @click="changeBetTab(4)">{{ sportAllBetLang['ALL_BET.HALF'] }}</div></template>
                                    <template v-if="selectedGrp.includes(5)"><div data-v-064a5016="" class="menu-item" :class="{'t_color':arr_selectedBetTab == 5}" @click="changeBetTab(5)">{{ sportAllBetLang['ALL_BET.SPECIALS'] }}</div></template>
                                    <template v-if="selectedGrp.includes(6)"><div data-v-064a5016="" class="menu-item" :class="{'t_color':arr_selectedBetTab == 6}" @click="changeBetTab(6)">{{ sportAllBetLang['ALL_BET.OTHER'] }}</div></template>
                                    <template v-if="selectedGrp.includes(9)"><div data-v-064a5016="" class="menu-item" :class="{'t_color':arr_selectedBetTab == 9}" @click="changeBetTab(9)">{{ sportAllBetLang['ALL_BET.INNINGS'] }}</div></template>
                                    <template v-if="selectedGrp.includes(10)"><div data-v-064a5016="" class="menu-item" :class="{'t_color':arr_selectedBetTab == 10}" @click="changeBetTab(10)">{{ sportAllBetLang['ALL_BET.TEAMS'] }}</div></template>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <allBet :selectedBetTab="arr_selectedBetTab"></allBet>
                </div>
                <div data-v-58c1d432="" class="details-ref" v-if="isShowBottomRefresh" @click="reloadAllBetTable">
                    <div data-v-58c1d432="" class="" :class="{'refreshing':refreshAllBet}"></div>
                </div>
                <div data-v-2ba1a780="" data-v-58c1d432="" class="info-rules fullscreen" v-if="showNotice">
                    <div data-v-2ba1a780="" class="content-box">
                        <header data-v-2ba1a780="">赛事直播说明</header>
                        <div data-v-2ba1a780="">
                            <div class="rules-wet">1</div>
                            &nbsp;&nbsp;此版面显示的所有直播内容<span class="font-wet">仅供参考，</span>会员亦可使用此内容为指南。我们将尽最大的努力确保显示的内容是正确的，如有错误，本公司将不承担任何责任。
                        </div>
                        <div data-v-2ba1a780="">
                            <div class="rules-wet">2</div>
                            &nbsp;&nbsp;对于滚球比分，例如滚球让球，将<span class="font-wet">以投注时在投注单中显示的正确比分为准</span>
                        </div>
                        <footer data-v-2ba1a780="" @click="showNotice=false;">我知道了</footer>
                        <!---->
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'

    import moment from 'moment'
    import allBetMixin from '@/vue/mixins/allBet'
    import loadingScreen from '@/vue/components/loadingScreen'
    import EventBus from '@/vue/events/event-bus'

    import sportFavourite from '@/vue/mixins/favourite'

  export default {
    mixins: [allBetMixin, sportFavourite],
    props:{
        
    },
    components: {
        loadingScreen,
    },
    computed: {
        ...mapGetters([
            'int_marketToggle',
            'arr_allBetEvent',
            'sportAllBetLang',
            'sportTableLang',
            'sportBettypeList',
            'arr_selectedTemplate',
            'isMobile',
            'arr_selectedBetTab',
            'loadingScreen',
            'isCollapse',
            'showMoreEvent',
            'scAllBetTab',
            'bkAllBetTab',
            'osAllBetTab',
            'arr_eventList',
            'arr_selectedEvent',
            'refreshAllBet',
            'tvIconFlag',
            'bettingFormToggle',
            'bettingSelection',
            'bettingMessage',
            'showHelp',
            'isShowBottomRefresh',
            'timeZone',
            'arr_lang',
        ]),
    },
    data() {
        return {
            cookies_lang: window._cookie,
            content: '',
            timerCount: 60,
            timerIdCount: null,
            selectedGrp: [],
            isRB: false,
            showNotice:false,
            closeTvWindow: true,
            tvlink: null,
        }
    },
    methods:{
        checkStart(end){
            var startTime = new moment().utcOffset("-04:00").format("YYYY-MM-DD HH:mm:ss");
            var endTime = moment(end);
            var difference = endTime.diff(moment(startTime), 'minutes')
            if (difference > 0) {
                return difference;
            }
            return 10000
        },
        matchDateCheck(date){
            return moment.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss")
        },
        startTv(allBet){   
            if(this.$store.getters.account.previewFlag){
             //   alert('Please Login')
             //   return false;
            }
            // this.loading = true;    
            this.$ajax({
            url: _baseUrl + '/livetv',
            type: 'post',
            data: {
                chlid: allBet.ch, 
                eventid: allBet.eveid,
                league: allBet.lgecapt,
                tacap: allBet.tacapt,
                tbcap: allBet.tbcapt
            }
            }).then(response => {
            //    this.loading = false;
                if(response!='error'){
                    this.tvlink = response;
                    this.closeTvWindow=false
                }else{
                    alert(this.arr_lang.LivetvLang['LIVETV.Stream_Error'])
                }
            })
        },
        videoClose(){ 
            this.closeTvWindow = !this.closeTvWindow
        },

        getTime(dt){
            return new moment(dt).format("HH:mm")
        },
        getDate(dt){
            if(this.cookies_lang=='zh_TW' || this.cookies_lang == 'zh_CN'){
                return new moment(dt).format("MM / DD")  
            }
            return new moment(dt).format("DD / MM")
        },
        startTimer() {
            if(this.timerIdCount == null){
                this.timerIdCount = setInterval(() => {
                    if(this.timerCount - 1 < 0) {
                        this.forAllBetTitle();
                    } else {
                        this.timerCount -= 1;
                    }
                },1000);
            }
        },
        clearTimer() {
            if(this.timerIdCount != null){
                clearInterval(this.timerIdCount);
                this.timerIdCount = null;
            }
        },
        forAllBetTitle() {
            let d = $('#myDiv')
            if(d.length){
                if ($('#myDiv')[0].scrollWidth > $('#myDiv')[0].clientWidth) {
                    $('#myDiv')[0].innerHTML = '<marquee>' + $('#myDiv')[0].innerHTML + '</marquee>';
                    this.startTimer()
                }
            }
        },
        changeBetTab(tab) {
            this.$store.commit('SELECTEDBETTYPE', tab)
            // this.$store.commit('LOADINGSCREEN',true)
        },
        showHideAllOdds() {
            if(this.isCollapse){
                this.$store.commit('IS_COLLAPSE', false)
                $('.odd').css('display','none')
                $('.row.items-center').addClass('bottom-style')
            }else{
                this.$store.commit('IS_COLLAPSE', true)
                $('.odd').css('display','block')
                $('.row.items-center').removeClass('bottom-style')
            }
        },
        goBack() {
            this.$store.commit('MARKET_BUTTON_TOGGLE',false)
            if(this.$store.getters.arr_selectedTemplate.templateId==6){
               this. sportTemplate_AllBet(this.arr_selectedTemplate.sportId);
                this.$store.commit('IS_RESULT_SCHEDULE', true)
            }else {
                window.history.go(-1)
            }
        },
        showMoreMatch(){
            if(this.$store.getters.showMoreEvent){
                this.$store.commit('SHOWMOREEVENT', false)
                $('body').removeClass('q-body--prevent-scroll')
            }else{
                this.$store.commit('SHOWMOREEVENT', true)
                $('body').addClass('q-body--prevent-scroll')
            }
        },
        sportBackground(sportid, mod){
            let display = ''
            if(mod==1){
                display = 'display: block;'
            }
            if(sportid=='N1'){
                return 'background: url(assets/images/score/football.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N2'){
                return 'background: url(assets/images/score/basketball.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N13'){
                return 'background: url(assets/images/score/american_football.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N3'){
                return 'background: url(assets/images/score/tennis.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N21'){
                return 'background: url(assets/images/score/volleyball.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N12'){
                return 'background: url(assets/images/score/badminton.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N24'){
                return 'background: url(assets/images/score/ping_pong.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N23'){
                return 'background: url(assets/images/score/baseball.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N15'){
                return 'background: url(assets/images/score/snooker_pool.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N7'){
                return 'background: url(assets/images/score/baseball.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N14'){
                return 'background: url(assets/images/score/ice_hockey.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N19'){
                return 'background: url(assets/images/score/handball.jpg) center center / 100% no-repeat content-box content-box; '+display
            }else if(sportid=='N20'){
                return 'background: url(assets/images/score/DOTA.jpg) center center / 100% no-repeat content-box content-box; '+display
            }
        },
        checkBetGroup(grp) {
            // check all bet bettype with bet tab bettype
            let availableGroup = ''
            let con = true

            if(this.arr_selectedTemplate.sportId=='N1'){
                availableGroup = this.scAllBetTab[grp]
                if(grp == 4){
                    if(this.arr_allBetEvent!=null && !_.isUndefined(this.arr_allBetEvent.od)){
                        if(!_.isUndefined(this.arr_allBetEvent.od[2])){
                            _.forEach(this.arr_allBetEvent.od[2], function(pval,btype){
                                if(_.includes(availableGroup, btype)){
                                    con = false
                                    return false
                                }
                            })
                        }
                       
                        if(!_.isUndefined(this.arr_allBetEvent.od[19])){
                            _.forEach(this.arr_allBetEvent.od[19], function(pval,btype){
                                if(_.includes(availableGroup, btype)){
                                    con = false
                                    return false
                                }
                            })
                        }
                    }
                }else if(grp == 5){
                    if(this.arr_allBetEvent && this.arr_allBetEvent.sp) {
                        con = false
                    }
                    if(con && this.arr_allBetEvent && !_.isUndefined(this.arr_allBetEvent.od)){
                        _.forEach(this.arr_allBetEvent.od, function(pval,plytype){
                            _.forEach(pval, function(val, btype){
                                if(_.includes(availableGroup, btype)){
                                    con = false
                                    return false
                                }
                            })
                        })
                    }
                }else{
                    if(this.arr_allBetEvent!=null && !_.isUndefined(this.arr_allBetEvent.od)){
                        _.forEach(this.arr_allBetEvent.od, function(pval,plytype){
                            _.forEach(pval, function(val, btype){
                                if(_.includes(availableGroup, btype)){
                                    con = false
                                    return false
                                }
                            })
                        })
                    }
                }
            }else if(this.arr_selectedTemplate.sportId=='G1'){
                availableGroup = this.bkAllBetTab[grp]
                if(this.arr_allBetEvent!=null && !_.isUndefined(this.arr_allBetEvent.od)){
                    _.forEach(this.arr_allBetEvent.od, function(pval,plytype){
                        _.forEach(pval, function(val, btype){
                            if(_.includes(availableGroup, btype)){
                                con = false
                                return false
                            }
                        })
                    })
                }
            }else{
                if(grp == 9){
                    availableGroup = this.osAllBetTab[grp]
                    if(this.arr_allBetEvent!=null && !_.isUndefined(this.arr_allBetEvent.od)){
                        _.forEach(this.arr_allBetEvent.od, function(pval,plytype){
                            if(_.includes(availableGroup, plytype)){
                                con = false
                                return false
                            }
                        })
                    }
                }else{
                    availableGroup = this.osAllBetTab[grp]
                    if(this.arr_allBetEvent && !_.isUndefined(this.arr_allBetEvent.od)){
                        _.forEach(this.arr_allBetEvent.od, function(pval,plytype){
                            _.forEach(pval, function(val, btype){
                                if(_.includes(availableGroup, btype)){
                                    con = false
                                    return false
                                }
                            })
                        })
                    }
                }
            }
            if(con==false){
                if(!_.includes(this.selectedGrp, grp)){
                    this.selectedGrp.push(grp)
                    this.$store.commit('SELECTEDBETTYPE', this.selectedGrp[0])
                }
            }
        },
        updateSelectedGrp(grp){
            this.selectedGrp = grp
        },
        reloadAllBetTable(){
            this.$store.commit('REFRESHALLBET', true)
            EventBus.$emit('reloadAllBet')
        },
        updateBetGroup(){
            this.checkBetGroup(8)
            this.checkBetGroup(1)
            this.checkBetGroup(2)
            this.checkBetGroup(3)
            this.checkBetGroup(4)
            this.checkBetGroup(5)
            this.checkBetGroup(6)
            this.checkBetGroup(7)
            this.checkBetGroup(9)
            this.checkBetGroup(10)
        },
        sportTemplate_AllBet(sportId){
            let vue = this
            
            this.$store.commit('SELECTED_TEMPLATE', {
                sportId: sportId,
                marketKey: vue.int_marketToggle,
                subTemplateId: vue.$store.getters.arr_selectedTemplate.subTemplateId
            })
            
            this.$store.commit('SELECTED_SPORT', sportId)
            var bettypeid = sportId.split('')
            if(bettypeid.length >= 3){
                bettypeid = bettypeid[1]+""+bettypeid[2]
            }else{
                bettypeid = bettypeid[1]
            }
            EventBus.$emit('enableLoading',true)
            this.changeSubTemplate(vue.$store.getters.arr_selectedTemplate.subTemplateId, sportId)
            this.$store.commit('SELECTED_MARKET', this.int_marketToggle)
        },
        changeSubTemplate(subTemplateId, sportId = null){
            
            if(this.account.previewFlag && subTemplateId=='3'){
                alert(lang.info7);
                return false;
            }

            if(this.account.previewFlag && subTemplateId=='3'){
                alert(lang.info7);
                return false;
            }

            if(((this.$store.getters.int_marketToggle == '1' || this.$store.getters.int_marketToggle == '2' ) && subTemplateId == 2)
                || (this.$store.getters.int_marketToggle == '2' && subTemplateId == 1)) {
                    this.$store.commit('SELECTED_PAYLAY_DATE', 99)
                if(this.$store.getters.int_marketToggle == '1' && subTemplateId == 2) {
                    this.$store.commit('SELECTED_PAYLAY_DATE', 0)
                }
                this.selectedDate = this.int_selectedParlayDate
            }

            if((account.previewFlag==undefined) || (account.previewFlag && this.$store.getters.int_marketToggle!='1')){//(account.previewFlag==undefined && market!='3') ||
                var btemplateId = 2;
            } else if ((account.previewFlag && this.$store.getters.int_marketToggle=='1')){ //|| (account.previewFlag==undefined && market=='3')
              var btemplateId = 3;
              this.$store.commit('SEL_MATCH', true)
            } 
            
            
            this.$store.dispatch('changeTemplate', {
                templateId: btemplateId,
                marketKey: this.$store.getters.int_marketToggle,
                plytype: 1,
                bettypeid: this.arr_selectedTemplate.bettypeid,
                sportId: sportId != null ? sportId : this.arr_selectedTemplate.sportId,
                subTemplateId: subTemplateId,
            })
            if(subTemplateId == '3'){
                this.$store.dispatch('getOutrightLeague', {
                    token: token.arr_2,
                })
            }else{
                if(this.$store.getters.int_marketToggle == '3'){
                    this.$store.dispatch('getLiveSportOdds', {
                        enableLoading:true,
                        token: token.arr_2,
                    })
                }else{
                    //this.$store.commit('SUBLOAD', true)
                    if(this.$store.getters.isSpecial)
                    {
                        this.$store.dispatch('getSpecialEventOdds', {
                            enableLoading:true,
                            token: token.arr_2,
                        })
                    }
                    else
                    {
                        if(this.isOtr){
                            this.$store.dispatch('getOutrightLeague', { token: token.arr_1 })
                        }else{
                            EventBus.$emit('resetTimer')
                            if(this.$store.getters.arr_selectedTemplate.marketKey==1){
                                this.$store.dispatch('getTodayRBSportOdds', {
                                    loading:0,
                                    token: token.arr_2,
                                    isGameBanner: 0,
                                })
                            } else {
                                this.$store.dispatch('getSportOdds', {
                                    enableLoading:true,
                                    token: token.arr_2,
                                    isGameBanner: 0,
                                })
                            }
                        }
                    }
                }
            }
        },
    },
    beforeMount() {
        EventBus.$on('startTvDefault', ((event) => {
            this.startTv(event)
        }).bind(this))
    },
    beforeDestroy() {
      EventBus.$off('startTvDefault')
    },
    mounted() {
        this.updateBetGroup()
        let Vue  = this
     
    },
    updated() {
        this.forAllBetTitle()
        this.updateBetGroup()
    },
    created() {
    },
    destroyed () {
        this.clearTimer()
    },
  }

 
</script>
<style lang="scss">
    #myDiv {
        overflow: hidden;
        white-space: nowrap;
        width: 200px;
    }
</style>


// WEBPACK FOOTER //
// resources/score/vue/apps/sport/allBet/allBetHeader.vue